export default "__VITE_ASSET__Dtlghjls__"